var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"search-icon LKIconSearch"},[(_vm.loading)?_c('v-icon',[_vm._v(" mdi-spin mdi-sync ")]):_c('img',{attrs:{"src":"/images/icon-search.svg","loading":"lazy","alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }